<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        unidade_negocio_id: null,
        unidade_negocio_descricao: '',
        unidade_negocio_pedido_valor_minimo: '',
        unidade_negocio_pic_valor_minimo: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$bvModal.hide(this.idModal);
      // const isValid = await this.$refs.refFormData.validate()
      // if (isValid) {
      //   this.$emit('ok', this.dataForm)
      //   this.$bvModal.hide(this.idModal)
      // }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      :id="idModal"
      :title="titleModal"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
  <!-- :ok-disabled="!dataForm.unidade_negocio_descricao && !dataForm.unidade_negocio_id || dataForm.disabledInput -->
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Código"
                label-for="unidade_negocio_id"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Código"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.unidade_negocio_id"
                    id="item_id"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Ex. CD001"
                    :disabled="dataForm.disabledInput"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Descrição"
                label-for="unidade_negocio_descricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.unidade_negocio_descricao"
                    id="unidade_negocio_descricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Descrição"
                    :disabled="dataForm.disabledInput"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
